import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class EmbalajeGrupo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'embalaje-grupo/one', saveUrl: 'embalaje-grupo/save', backUrl: '/Catalogo/GruposEmbalajes' },
      new Form([
        Form.Field('text', 'grupo', 'Grupo', '', [Validators.required], 6),
      ], ['Guardar'], 'Grupo de Embalaje'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(EmbalajeGrupo)
